import React from 'react';
import t from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { baseUrl, appIdentity } from '../../../utils/http';
import { getLocaleFromCookie } from '../../lang/LocalizationProvider';

import styles from './SocialButton.scss';

/**
 * Renders a styled button for social log in on one of the following platforms: Apple, Facebook or Google.
 * Will redirect to appropriate OAuth page on click.
 * @param prop
 * @param {string} prop.title
 * @returns {JSX.Element}
 */
const SocialButton = ({ title }) => {
  const onClick = () => (window.location = `${baseUrl}/v1/account/oauth/${title.toLocaleLowerCase()}/login?app-identity=${appIdentity}&locale=${getLocaleFromCookie()}`);

  return (
    <button className={`${styles.socialButton} ${styles[`socialButton-${title.toLocaleLowerCase()}`]}`} onClick={onClick} type="button">
      <FormattedMessage
        id="enter.socialButton"
        defaultMessage="Continue with"
        description="Button for logging in with a 3rd-party service, is followed by the name of service: AppleID, Facebook, Google"
      /> {title}
    </button>
  );
};

SocialButton.propTypes = {
  title: t.oneOf(['Apple', 'Facebook', 'Google', 'Setapp'])
};

export default SocialButton;
